exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".modal__AddOneTimeProductModal-module___24QUY {\n  background-color: #0000001d;\n}\n\n.inputPrice__AddOneTimeProductModal-module___123R3 {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  width: 190px;\n}\n.decoration__AddOneTimeProductModal-module___nZOGb {\n  height: 100%;\n}\n\n.buttonContainer__AddOneTimeProductModal-module___2KUWo {\n  display: flex;\n  gap: 8px;\n  margin-top: 24px;\n}\n\n.container__AddOneTimeProductModal-module___2-W-7 {\n  margin-bottom: 8px;\n}\n", ""]);

// Exports
exports.locals = {
	"modal": "modal__AddOneTimeProductModal-module___24QUY",
	"inputPrice": "inputPrice__AddOneTimeProductModal-module___123R3",
	"decoration": "decoration__AddOneTimeProductModal-module___nZOGb",
	"buttonContainer": "buttonContainer__AddOneTimeProductModal-module___2KUWo",
	"container": "container__AddOneTimeProductModal-module___2-W-7"
};